import { HistoryFiltersTypes } from "@zapier/reporting/src/types";

type FilterName = keyof HistoryFiltersTypes;

export function areFiltersEmpty(filters: Partial<HistoryFiltersTypes>) {
  const possiblyUndefinedFilters = ["app", "folderId", "nodeId", "ownerId"];
  const filtersAreEmpty =
    Object.keys(filters)
      .filter((filter) => possiblyUndefinedFilters.includes(filter))
      .every((filter) => filters[filter as FilterName] === undefined) &&
    filters.search === "" &&
    Object.keys(filters.dateFilter || {}).length === 0 &&
    Object.keys(filters.status || []).length === 0;

  return filtersAreEmpty;
}

/**
 * Returns the names of the active filters (or an empty string if there are none)
 */
export function getActiveFilterNames(filters: Partial<HistoryFiltersTypes>) {
  const isFilterActive = (filterName: FilterName) => {
    const filterValue = filters[filterName];

    if (filterName === "dateFilter" || filterName === "page") {
      return false;
    }

    if (Array.isArray(filterValue)) {
      return filterValue.length > 0;
    }

    return Boolean(filterValue);
  };

  const filterKeys = (Object.keys(filters) as FilterName[])
    .filter(isFilterActive)
    .sort((a, b) => a.localeCompare(b));

  return filterKeys.join(",");
}
